import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {environment} from '../../../../../environments/environment';


export interface Taxe {
  id: number;
  client_id: number;
  station_id: number;
  nom: string;
  label: string;
  valeur: number;
  valeur_fixe: boolean;
  valeur_pourcentage: boolean;
  applique_avant_tva: boolean;
  applique_apres_tva: boolean;
  /** Appliqué à la TVA (ex. FODEC) - colonne table applique_tva */
  applique_tva?: boolean;
  /** @deprecated utiliser applique_tva */
  applique_a_la_tva?: boolean;
  taxe_applique_sur_produits: boolean;
  type: '+' | '-';
  applique_sur_product: boolean;
  /** Si true, la taxe s’applique sur tous les documents (API : applique_sur_tous_document). */
  applique_sur_tous_document?: boolean;
  /** Portée d’utilisation (mutuellement exclusif côté UI : Tous / Ventes / Achat). */
  utilisation_tous?: boolean;
  utilisation_vente?: boolean;
  utilisation_achat?: boolean;
  statut: boolean;
}

export interface ApiResponse {
  success: boolean;
  taxe?: Taxe;
  taxes?: Taxe[];
  message: string;
}

@Injectable({
  providedIn: 'root'
})
export class TaxeService {
    private apiUrl = `${environment.parameters_url}api/settings/taxe`;

  constructor(private http: HttpClient) {}

  createTaxe(taxe: Taxe, stationId: number): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(`${this.apiUrl}/${stationId}`, taxe);
  }

  updateTaxe(taxe: Taxe, stationId: number): Observable<ApiResponse> {
    return this.http.put<ApiResponse>(`${this.apiUrl}/${stationId}/${taxe.id}`, taxe);
  }


   getTaxeList(stationId: number): Observable<ApiResponse> {
     return this.http.get<ApiResponse>(`${this.apiUrl}/${stationId}`);
     
   }
  
}
